import { Navigate, useTypedParams } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MY_CARDS_CARDS,
  ANY_SPORT_MY_CARDS_GALLERY,
  ANY_SPORT_MY_CARDS_GALLERY_RARITY_SET,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnableSetFeatures } from '@sorare/core/src/hooks/commonGame/useEnableSetFeatures';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { useMyCardsContext } from '#src/contexts/myCards/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const GalleryRarityPage = () => {
  const { cardSets } = useMyCardsContext();
  const { rarity } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();
  const enableSetFeatures = useEnableSetFeatures();
  const setToRedirectTo = cardSets.at(0)?.slug || null;
  if (!isRarityStr(rarity)) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_GALLERY)}
        replace
      />
    );
  }

  if (!setToRedirectTo) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_CARDS)}
        replace
      />
    );
  }

  if (rarity !== Rarity.common || !enableSetFeatures) {
    return null;
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_GALLERY_RARITY_SET, {
        params: { rarity, set: setToRedirectTo },
      })}
      replace
    />
  );
};
export default GalleryRarityPage;
